import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocalization } from '../contexts/LocalizationContext';

const GuestNavbar = ({ onGetStarted, showGetStarted = true, showAbout = true }) => {
  const { t, changeLanguage, availableLanguages, language } = useLocalization();
  const [selectedLanguage, setSelectedLanguage] = useState(language);
  const navigate = useNavigate();

  const handleLanguageChange = (langCode) => {
    setSelectedLanguage(langCode);
    changeLanguage(langCode);
  };

  const handleGetStarted = () => {
    if (onGetStarted) {
      onGetStarted();
    } else {
      // Fallback to direct navigation if no callback provided
      navigate('/auth');
    }
  };

  return (
    <header className="wrapper bg-soft-primary">
      <nav className="navbar navbar-expand-lg center-nav transparent navbar-light">
        <div className="container flex-lg-row flex-nowrap align-items-center">
          <div className="navbar-brand w-100">
            <Link to="/" className="text-decoration-none">
              <h2 className="mb-0" style={{ fontFamily: 'Thicccboi, sans-serif', color: '#2563eb', fontWeight: '700', fontSize: '1.25rem' }}>Poligon</h2>
            </Link>
          </div>
          <div className="navbar-other w-100 d-flex ms-auto">
            <ul className="navbar-nav flex-row align-items-center ms-auto">
              {showAbout && (
                <li className="nav-item d-none d-md-block">
                  <Link 
                    to="/about" 
                    className="nav-link text-decoration-none text-uppercase fw-medium"
                    style={{ fontFamily: 'Thicccboi, sans-serif', fontSize: '0.875rem', letterSpacing: '0.05em', color: '#374151' }}
                  >
                    {t('navigation.about')}
                  </Link>
                </li>
              )}
              <li className="nav-item dropdown language-select text-uppercase">
                <button className="nav-link dropdown-item dropdown-toggle border-0 bg-transparent"  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {selectedLanguage.toUpperCase()}
                </button>
                <ul className="dropdown-menu">
                  {availableLanguages.map(lang => (
                    <li key={lang.code} className="nav-item">
                      <button 
                        className="dropdown-item border-0 bg-transparent w-100 text-start" 
                        onClick={() => handleLanguageChange(lang.code)}
                      >
                        {lang.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </li>
              {showGetStarted && (
                <li className="nav-item d-none d-md-block">
                  <button 
                    className="btn btn-sm btn-primary rounded-pill" 
                    onClick={handleGetStarted}
                  >
                    {t('landing.getStarted') || 'Get Started'}
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default GuestNavbar;